/**
 * Accepts a non-negative decimal number string (digits, optional single fractional part).
 * Returns the number when valid; otherwise `null` (caller skips).
 */
export const parseNumValue = (raw: string): number | null => {
    const normalized = raw.trim();

    if (!/^\d+(\.\d+)?$/.test(normalized)) {
        return null;
    }

    const parsed = Number(normalized);

    return Number.isFinite(parsed) ? parsed : null;
};
